import { render, staticRenderFns } from "./MaxparIntegrationContent.vue?vue&type=template&id=3b3ba18f"
import script from "./MaxparIntegrationContent.vue?vue&type=script&lang=js"
export * from "./MaxparIntegrationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports